<template lang="pug">
  .w-full.mt-4
    .flex.items-center.gap-2.justify-center.prose.dark_prose-invert.max-w-full(v-if="hasCustomisations")
      Icon(icon="emojione:warning")
      span <strong class="dark_text-primary-300 text-primary-700 font-bold"> {{ filteredList.length }}/{{ report?.total }} {{ justOne ? 'customisation' : 'customisations' }} </strong> may need to be updated!
      Icon(icon="emojione:warning")
    .flex.items-center.gap-2.justify-center.prose.dark_prose-invert.max-w-full(v-else="")
      Icon(icon="fluent-emoji:thumbs-up")
      span No customisations for this course need to be updated.
      Icon(icon="fluent-emoji:thumbs-up")

    .custom-report-table-container.overflow-y-auto.mt-2.prose.dark_prose-invert.max-w-full(
      class="max-h-[20vh]"
      v-if="hasCustomisations"
    )
      table.updates.my-0
        thead
          tr
            th Firm
            th Last Updated
            th Patches ({{report?.patches}})
            //- th Audio
            th Patched Audio ({{report?.patchedAudio}})
            th Translations ({{report?.translations}})
        tbody
          tr(
            v-for="item in filteredList"
            :key="item.firmCode+item.courseId"
          )
            td 
              a.font-bold.text-primary-500(target="_blank" :href="`#/editor/${item.firmCode}_${item.courseId}`") {{ item.firmCode }}_{{ item.courseId }}
            td {{ new Date(+item.createdDate).toLocaleDateString('en-GB', { month: 'short', day: 'numeric', year: 'numeric' }) }}
            td(:class="{ 'opacity-50': !item.hasPatches }") {{ item.hasPatches ? '✔' : '-' }}
            //- td(:class="{ 'opacity-50': !item.hasAudio }") {{ item.hasAudio ? '✔' : '-' }} 
            td(:class="{ 'opacity-50': !item.hasPatchedAudio }") {{ item.hasPatchedAudio ? '✔' : '-' }}
            td(:class="{ 'opacity-50': !item.hasTranslations }") {{ item.hasTranslations ? item.languages.length : '-' }}
      
      template(v-if="otherCustomisationsList.length > 0")
        .flex.items-center.gap-2.justify-center.prose.dark_prose-invert.max-w-full.mt-10
          span There {{ justOneOther ? 'is' : 'are' }} <strong class="dark_text-primary-300 text-primary-700 font-bold"> {{ otherCustomisationsList.length }} </strong> other {{ justOneOther ? 'customisation' : 'customisations' }}
        
        table.my-0
          thead
            tr
              th Firm
              th Last Updated
          tbody
            tr(
              v-for="item in otherCustomisationsList"
              :key="item.firmCode+item.courseId"
            )
              td 
                a.font-bold.text-primary-500(target="_blank" :href="`#/editor/${item.firmCode}_${item.courseId}`") {{ item.firmCode }}_{{ item.courseId }}
              td {{ new Date(+item.createdDate).toLocaleDateString('en-GB', { month: 'short', day: 'numeric', year: 'numeric' }) }}

    p.flex.gap-2.items-center.flex-row-reverse(
        v-if="hasCustomisations"
      )
      button.text-primary-600.hover_text-primary-700.p-2(
        @click="copyTableToClipboard"
        type="button"
      )
        | Copy table to clipboard
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Icon } from '@iconify/vue';

const props = defineProps<{
  report: CustomReport | null;
}>();

const filteredList = computed(() =>
  props?.report?.list?.filter(
    item => item.hasTranslations || item.hasPatchedAudio || item.hasPatches
  )
);

const otherCustomisationsList = computed(() =>
  props?.report?.list?.filter(
    item => !item.hasTranslations && !item.hasPatchedAudio && !item.hasPatches
  )
);

const justOne = computed(() => filteredList?.value?.length === 1);
const justOneOther = computed(
  () => otherCustomisationsList?.value?.length === 1
);
const hasCustomisations = computed(() => filteredList?.value?.length ?? 0 > 0);

async function copyTableToClipboard() {
  const table = document.querySelector(
    '.custom-report-table-container table.updates'
  );
  const range = document.createRange();
  range.selectNode(table);
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);

  const tableText = selection?.toString();
  try {
    await navigator.clipboard.writeText(tableText ?? '');
    console.log('Table copied to clipboard');
  } catch (err) {
    console.error('Failed to copy table: ', err);
  }

  selection?.removeAllRanges();
}
</script>

<style scoped>
th,
td {
  text-align: center;
  vertical-align: middle;
}
</style>
